import { AlertTriangle } from "lucide-react";
import type { BacktestResult } from "@/api/types";
import { startDateWarning } from "@/lib/backtest-stats";
import { useTimezoneStore } from "@/stores/timezone";

/** Amber banner when the first candle is later than the requested start (or missing). */
export function StartDateWarning({ result }: { result: BacktestResult }) {
  const mode = useTimezoneStore((s) => s.mode);
  const message = startDateWarning(result, mode);
  if (!message) return null;
  return (
    <div
      className="flex shrink-0 items-start gap-2 border-b border-[var(--border)] px-3 py-2 text-sm"
      style={{
        background: "color-mix(in srgb, var(--warning) 8%, transparent)",
        borderColor: "color-mix(in srgb, var(--warning) 35%, transparent)",
        color: "var(--warning)",
      }}
    >
      <AlertTriangle size={14} className="mt-0.5 shrink-0" aria-hidden />
      <span>{message}</span>
    </div>
  );
}
